import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import ICalloutRequestedStep from './types/ICalloutRequestedStep';
import DoneIcon from '@material-ui/icons/Done';
import { activeCompletedColor, stepIconContainerSize } from './calloutRequestedData';
import { ClassNameMap } from '@material-ui/styles';

interface StepIconlProps {
    step: ICalloutRequestedStep,
    activeStepId: number,
    isCallouFinished: boolean
};

const useStyles =  makeStyles(() => ({
    stepIconContainer: {
        width: stepIconContainerSize,
        height: stepIconContainerSize,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    stepIconBox: {
        width: 53,
        height: 53,
        backgroundColor: "white",
        borderRadius: 26,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2,
        opacity:'0.17'
    },
    stepIconBoxActiveCompleted: {
        width: 53,
        height: 53,
        backgroundColor: activeCompletedColor,
        borderRadius: 26,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2,
    },
    stepIconBoxCalloutFinished: {
        width: 53,
        height: 53,
        backgroundColor: 'white',
        opacity: '0.54',
        borderRadius: 26,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2,
    },
    stepIcon: {
        color: "#00152E",        
    },
}));

const getIconSyle = (classes: ClassNameMap, stepId: number, activeStepId: number, isCallouFinished:boolean) => {
    if(isCallouFinished){
        return classes.stepIconBoxCalloutFinished;
    }
    return stepId <= activeStepId? classes.stepIconBoxActiveCompleted : classes.stepIconBox;
}

const StepIcon: React.FC<StepIconlProps> = ({step, activeStepId, isCallouFinished}) => {
    const classes = useStyles();

    return (
    <div className={classes.stepIconContainer}>
        <span className={getIconSyle(classes, step.id, activeStepId, isCallouFinished)}>
            <DoneIcon className={classes.stepIcon} />
        </span>
    </div>
    );
}

export default StepIcon;